"use client";

export default function Error({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "50vh",
            padding: "20px",
            textAlign: "center",
        }}>
            <h2 style={{ marginBottom: "16px" }}>Something went wrong!</h2>
            <p style={{ color: "#666", marginBottom: "24px" }}>
                {error.message || "An unexpected error occurred"}
            </p>
            <button
                onClick={() => reset()}
                style={{
                    padding: "12px 24px",
                    backgroundColor: "#000",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "14px",
                }}
            >
                Try again
            </button>
        </div>
    );
}
